// Centralized CTA link building and click tracking.
//
// - Play Store links carry campaign attribution through the `referrer`
//   parameter (Google Play install referrer), encoding standard UTM fields.
// - Links to owned web properties (blog) carry plain UTM query params.
// - Click events are pushed to window.dataLayer (GTM-ready) and mirrored
//   to gtag when a GA tag is present. With no analytics script loaded the
//   calls are safe no-ops that only accumulate in dataLayer.

import { PLAY_STORE_BASE } from "../config/stores";

export { PLAY_STORE_BASE };

const UTM_SOURCE = "accruewise_website";

/** Play Store URL with install-referrer UTM attribution for a placement. */
export function playStoreUrl(campaign, medium = "cta") {
    const referrer = encodeURIComponent(
        `utm_source=${UTM_SOURCE}&utm_medium=${medium}&utm_campaign=${campaign}`
    );
    return `${PLAY_STORE_BASE}&referrer=${referrer}`;
}

/** Append UTM params to a URL on an owned property (e.g. the blog). */
export function withUtm(url, campaign, medium = "referral") {
    const u = new URL(url);
    u.searchParams.set("utm_source", UTM_SOURCE);
    u.searchParams.set("utm_medium", medium);
    u.searchParams.set("utm_campaign", campaign);
    return u.toString();
}

/** Push an analytics event. GTM-ready; mirrors to gtag when present. */
export function trackEvent(name, params = {}) {
    try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({ event: name, ...params });
        if (typeof window.gtag === "function") {
            window.gtag("event", name, params);
        }
    } catch (e) {
        // Analytics must never break the UI.
    }
}

/** Track a CTA click by placement (e.g. "home_hero", "header"). */
export function trackCta(placement, params = {}) {
    trackEvent("cta_click", { cta_placement: placement, ...params });
}
